export default __webpack_public_path__ + "static/media/popup_pergaminhos_01.81e79cb1.mp3";